import './App.css';
import * as React from 'react';
import 'react-tiff/dist/index.css'
import "leaflet/dist/leaflet.css";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './components/Login'; // This is your login component
import EIAM from './components/EIAM.js'; // This is your app component
//import TiffViewer from './components/TiffViewer.js';
const restserver = "http://localhost:5000/";




var folders = require('./images.json');

function srcset(image, size, rows = 1, cols = 1) {
  return {
    src: `${image}`,
    srcSet: `${image}`,
  };
}

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/home" element={<EIAM />} />
      </Routes>
    </Router>
  );
};

export default App;
/*
export default function App() {
  const [siteImages, setSiteImages] = React.useState(folders[0].children);
  const [testResp, setTestResp] = React.useState('');
  const [appStep, setStep] = React.useState(0);
  const [selectedSite, setSite] = React.useState('');
  const [selectedAlgo, setAlgo] = React.useState('');
  // const [folders,setfolders] = React.useState('[]')

  const selectSite = (newVal) => () => {
    if (newVal == undefined) {
      setStep(appStep + 1); return;
    }
    var newnode = searchNode(folders, newVal);
    console.log('siteSelect', newVal);
    if (newnode && newnode.children && newnode.label != selectedSite) {
      setSelectedRefItems('');
      setSelectedTrgItems('');
      setSiteImages(newnode.children)
      setSite(newnode.label);

      fetch('/app/' + newnode.site + '.geojson') // Replace with your URL
        .then(response => response.json())
        .then(data => setGeoJsonData(data))
        .catch(error => console.error('Error fetching data:', error));

    }
    console.log('siteSelect', newVal);
   // setStep(appStep + 1);

  };
  const selectAlgo = (newVal) => () => {
    setAlgo(newVal);
    console.log('siteSelect', newVal);
    setStep(appStep + 1);
  };

  const handleRefSelectedItemsChange = (event, ids) => {
    console.log('event', event, 'ids', ids);
    const node = searchNode(folders, ids);
    if (node && node.label && (!node.children || node.children.length == 0)) {
      setSelectedRefItems(node.label);
      setSelectedRefID(ids);
    }
  };
  const handleTrgSelectedItemsChange = (event, ids) => {
    console.log('event', event, 'ids', ids);
    const node = searchNode(folders, ids);
    if (node && node.label && (!node.children || node.children.length == 0)) {
      setSelectedTrgItems(node.label);
      setSelectedTrgID(ids);
    }
  };

  function searchNode(nodes, key) {
    //   console.log("SearchNode:",nodes,key);
    for (const node of nodes) {
      //  console.log("Looking :", node.id);
      // Check if the current node's id matches the key
      if (node.id === key) {
        //   console.log("Found:", node);
        return node;
      }

      // If there are children, perform a recursive search
      if (node.children && node.children.length > 0) {
        //   console.log("Looking Child:", node.id);
        const foundNode = searchNode(node.children, key);

        if (foundNode) {
          //     console.log("Child Found:", foundNode);
          return foundNode; // Return the found node
        }
      }
    }

    // Return null if the node was not found
    return null;
  }
  const [geoJsonData, setGeoJsonData] = React.useState(null);
  const [selectedRefItems, setSelectedRefItems] = React.useState([]);
  const [selectedTrgItems, setSelectedTrgItems] = React.useState([]);
  const [selectedRefID, setSelectedRefID] = React.useState('');
  const [selectedTrgID, setSelectedTrgID] = React.useState('');

  const GeoJSONOverlay = ({ data }) => {
    const map = useMap();
    React.useEffect(() => {
      if (data) {
        const geoJsonLayer = new L.GeoJSON(data);
        const bounds = geoJsonLayer.getBounds();
        map.fitBounds(bounds); // Center and zoom to GeoJSON bounds
      }
    }, [data, map]);
    return data ? <GeoJSON data={data} /> : null;
  };

  const handleStep = (panel) => (event, isExpanded) => {
    console.log('panel', panel, event, isExpanded);
    setStep(isExpanded ? panel : (appStep + 1));
  };

  const handleNRMSE = () => (event) => {
    console.log('Button Clicked', event);
    var url = restserver + 'test/nrmse/' + selectedRefID + '/' + selectedTrgID
    //var url='/test/nrmse/'+selectedRefID + '/' + selectedTrgID 
    console.log('url', url);
    fetch(url)
      .then(response => response.json())
      .then(data => setTestResp(data));
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <HeaderToolbar />
      <div className="App">

        {/* Sites Panel * / }
        <Accordion expanded={appStep == 0} onChange={handleStep(0)}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header"  >
           Site Selection:  <span className='headingCaps'>{selectedSite}</span>
          </AccordionSummary>
          <AccordionDetails>
          <div id="images">
      
          <ImageList variant="quilted" sx={{width: '50%', height: 450 }} cols={2} rowHeight={200}>
              {sitesData.map((item) => (
                <ImageListItem sx={{ border: 2, cursor: 'pointer' }} key={item.img} cols={item.cols || 1} rows={item.rows || 1} onClick={selectSite(item.id)}>
                  <img
                    {...srcset(item.img, 225, item.rows, item.cols)}
                    alt={item.title}
                    loading="lazy"
                  />
                  <ImageListItemBar
                    title={item.title}
                    subtitle={item.location}
                    actionIcon={
                      <IconButton
                        sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                        aria-label={`info about ${item.title}`}
                        onClick={selectSite(item.title)}
                      >
                        <InfoIcon />
                      </IconButton>
                    }
                  />
                </ImageListItem>
              ))}
            </ImageList>

      
          <Card sx={{ left: 50, minWidth: 275, maxWidth: '50%', height:450, background: "#eee" }}>
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    Site Images
                  </Typography>
                  <RichTreeView id="tree" items={siteImages} onSelectedItemsChange={handleRefSelectedItemsChange} />
                </CardContent>
                <CardActions>  <Alert severity="success">  {testResp.message}   </Alert>
                
                  <Button color="warning" variant="contained" onClick={handleNRMSE()}>Upload new images</Button>
                
                  <Button variant="contained" onClick={selectSite()}>Select images</Button>
                </CardActions>
              </Card>
           
          </div>
         
          </AccordionDetails>
        </Accordion>

        {/* Algorithm Panel * /}
        <Accordion expanded={appStep == 1} onChange={handleStep(1)}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2-content" id="panel2-header">
            Aircraft Detecton Results: <span className='headingCaps'>{selectedRefItems}</span>
          </AccordionSummary>
          <AccordionDetails>

          <MapContainer center={[51.505, -0.09]} zoom={13} scrollWheelZoom={true}>
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
              />

              <GeoJSONOverlay data={geoJsonData} />
            </MapContainer>
          </AccordionDetails>
        </Accordion>
        <Accordion expanded={appStep == 2} onChange={handleStep(2)}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2-content" id="panel2-header">
            Alerts Management
          </AccordionSummary>
          <AccordionDetails>

          <MapContainer center={[51.505, -0.09]} zoom={13} scrollWheelZoom={true}>
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
              />

              <GeoJSONOverlay data={geoJsonData} />
            </MapContainer>
          </AccordionDetails>
        </Accordion>
        {/* Images Panel * /}

      </div>
      <Footer />
    </ThemeProvider>
  );
}
*/
